export class PhoneNumberFormatter {

  static phoneNumberFormats = {
    US: '(000) 000-0000',
    UK: '0000 000000',
    FR: '00 00 00 00 00',
    RO: '0000 000 000'
  };

  static getFormattedPhoneNumber( num: string, countryCode: string= 'US') {
    if (!num) {
      return '';
    }
    if (!(countryCode in PhoneNumberFormatter.phoneNumberFormats)) {
      return num;
    }

    // removing any symbols from the number
    let temporaryString: string = '';
    for ( let i = 0; i < num.length; i++) {
      if ('0' <= num[i] && num[i] <= '9') {
        temporaryString += num[i];
      }
    }
    num = temporaryString;

    const formatString = PhoneNumberFormatter.phoneNumberFormats[countryCode];
    let newPhoneNumber: string = '';
    let numberIdx: number = 0;

    for ( let i = 0; i < formatString.length; i++ ) {
      if ( '0' <= formatString[i] && formatString[i] <= '9' ) {
        if ( numberIdx < num.length) {
          newPhoneNumber += num[numberIdx];
        }
        numberIdx++;
      }
      else {
        newPhoneNumber += formatString[i];
      }
    }

    return newPhoneNumber;
  }
}
